export default __webpack_public_path__ + "media/flags/cd-af7f42f2.svg";